// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select-clear-zone {
  display: none;
}

.limit-wrapper {
  display: flex;
  align-items: center;
}

.search-error {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/SearchOps/qclCorrection/qclCorrection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".Select-clear-zone {\n  display: none;\n}\n\n.limit-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.search-error {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
